<template>
  <div>
    <h1
      class="flex items-center font-semibold leading-none"
      style="height: 30.5px;"
    >
      Top 10 By Row Count
    </h1>
    <Chart
      v-if="params.length"
      type="bar"
      :data="chartData"
      :options="chartOptions"
      class="h-[30rem] w-full"
    />
    <div
      v-else
      class="flex flex-1 w-full items-center justify-center"
    >
      <ProgressSpinner />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useDark } from '@vueuse/core'

const darkMode = useDark()
const params = defineModel({ type: Array, default: [] })

const chartData = computed(() => {
  const stats = [...params.value]
  if (stats.length > 10) {
    const others = { objectName: 'Others', numDbRows: 0 }
    while (stats.length > 10) {
      const item = stats.pop()
      others.numDbRows += item.numDbRows
    }
    stats.push(others)
  }
  const documentStyle = getComputedStyle(document.documentElement)
  return {
    labels: (stats ?? []).map((item) => item.objectName),
    datasets: [
      {
        label: 'Rows',
        backgroundColor: documentStyle.getPropertyValue('--p-cyan-500'),
        data: (stats ?? []).map((item) => item.numDbRows)
      }
    ]
  }
})

const chartOptions = computed(() => {
  return {
    maintainAspectRatio: false,
    indexAxis: 'y',
    // aspectRatio: 0.6,
    plugins: {
      legend: {
        display: false
      },
      responsive: true
    },
    scales: darkMode.value
      ? {
          x: {
            ticks: {
              color: '#888888',
              maxRotation: 45,
              minRotation: 0
            },
            grid: {
              color: 'rgba(255, 255, 255, 0.2)'
            }
          },
          y: {
            ticks: {
              color: '#888888'
            },
            grid: {
              color: 'rgba(255, 255, 255, 0.2)'
            }
          }
        }
      : {
          x: {
            ticks: {
              maxRotation: 45,
              minRotation: 0
            }
          }
        }
  }
})
</script>
